export default __webpack_public_path__ + "static/media/snippets.7fc834cc.svg";